
/**
 * SelectFilter is a utility class to allow a dropdown/select to switch between options based on an external event.
 * For example, a select might originally have all the zipcodes for Washington and Oregon, but only want to display the zipcodes
 * based on the current state. This filter would facilitate that logic - to switch options presented based on stare.
 *
 * @constructor
 */
function SelectFilter(selectElementId, attributeName)
{
    this.selectElement = $("#" + selectElementId);
    this.attributeName = attributeName;
    this.options = [];

    this.populateOptions(this.selectElement, this.attributeName);
}

/**
 * Here we store all of the initial options so we can recall them later.
 *
 * @param selectElement
 * @param attributeName
 */
SelectFilter.prototype.populateOptions = function(selectElement, attributeName) {
    var that = this;

    selectElement.children("option").each(function(index, element) {
        that.options.push(element);
    });
};

/**
 * Update the select to only contain the options that have newAttributeValue for the attribute specified in attributeName in the constructor.
 *
 * @param newAttributeValue
 */
SelectFilter.prototype.update = function(newAttributeValue)
{
    this.selectElement.find('option').remove();

    var placeholderOption = this.options[0];

    this.selectElement.append(placeholderOption);

    var selectedValue = placeholderOption.value;

    for(var i = 1; i < this.options.length; i++) {
        var option = this.options[i];

        if( option.getAttribute(this.attributeName) === newAttributeValue ) {
            this.selectElement.append(option);

            if( option.getAttribute("selected") === "selected" ) {
                selectedValue = option.value;
            }
        }
    }
    
    this.selectElement.val(selectedValue);
};

function capitalizeFirstLetter(word) {
    var captialFirstLetter = word[0].toUpperCase();

    return captialFirstLetter + word.substr(1);
}


/**
 * Class to update text content
 * @param element
 * @param defaultText
 * @param prefix is the default text a prefix
 * @constructor
 */
function TextUpdater(element, defaultText, prefix) {
    this.element = $(element);

    this.textFormatter = capitalizeFirstLetter;
    this.defaultText = this.getText();
    this.prefix = true;
    this.separator = " ";

    if(defaultText !== undefined) {
        this.defaultText = defaultText;
    }

    if(prefix !== undefined) {
        this.prefix = prefix
    }
}

TextUpdater.prototype.setTextFormatter = function( callable ) {
    this.textFormatter = callable;
};

TextUpdater.prototype.setSeparator = function(value) {
    this.separator = value;
};

TextUpdater.prototype.update = function(newName) {
    var formattedName = this.textFormatter(newName);

    var newText = formattedName + this.separator + this.defaultText;

    if(this.prefix) {
        newText = this.defaultText + this.separator + formattedName;
    }

    this.setText(newText);
};

TextUpdater.prototype.getText = function() {
    var tagName = this.element.prop("tagName");

    switch(tagName) {
        default:
            return this.element.text();
    }
};

TextUpdater.prototype.setText = function(value) {
    var tagName = this.element.prop("tagName");

    switch(tagName) {
        default:
            this.element.text(value);
            break
    }
};